
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';

import { DossierModel } from './dossier-model';

const DossierModelQuery = require('./dossier-model.query.gql');

/**
 * Service to manage dossier model
 */
@Injectable()
export class DossierModelService {

  private _dossierModel: Observable<DossierModel>;


  constructor(private apollo: Apollo) {
    // Init current user
    this._dossierModel = this.apollo.watchQuery({
      query: DossierModelQuery
    })
    .valueChanges
    .pipe(map((value) => new DossierModel(value.data['dossierModel'])));
  }


  get dossierModel() {
    return this._dossierModel;
  }
}